import { render, staticRenderFns } from "./TV.vue?vue&type=template&id=b95328b8&scoped=true&"
import script from "./TV.vue?vue&type=script&lang=js&"
export * from "./TV.vue?vue&type=script&lang=js&"
import style0 from "./TV.vue?vue&type=style&index=0&id=b95328b8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b95328b8",
  null
  
)

export default component.exports